import { render, staticRenderFns } from "./GridDetail.vue?vue&type=template&id=33561524&scoped=true"
import script from "./GridDetail.vue?vue&type=script&lang=js"
export * from "./GridDetail.vue?vue&type=script&lang=js"
import style0 from "./GridDetail.vue?vue&type=style&index=0&id=33561524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33561524",
  null
  
)

export default component.exports